import { DateOfStay } from '../../../objects/date-of-stay';
import { Destination } from '../../../objects/destination';
import { DestinationSelectSetting } from '../../../objects/destination-select-setting';
import { Directive, Signal } from '@angular/core';

@Directive()

export abstract class EntryStepperBase {
  abstract readonly destinations: Signal<Destination[] | null>;
  abstract readonly destination: Signal<Destination | null>;
  abstract readonly destinationSelectSetting: Signal<DestinationSelectSetting>;

  abstract readonly dateOfStay: Signal<DateOfStay | null>;
  dateVisible: boolean = false;
  showDates = true;

  /**
   * Triggered when destination selected.
   *
   * @param destination selected destination
   */
  selectDestination(destination: Destination | null) {

    this.didDestinationChange(destination);

  }

  /**
   * Triggered when date selected.
   *
   * @param dateOfStay selected date of stay or partial date of stay
   */
  selectDateOfStay(dateOfStay: DateOfStay) {
    if (dateOfStay.start && dateOfStay.end) {
      this.showDates = false;
    }

    this.didDateOfStayChange(dateOfStay);
  }

  /**
   * Triggered when start date is blurred.
   * Shows date picker and reset dateOfStay.
   */
  onStartDateBlurred() {
    this.showDates = true;

    const dateOfStay = new DateOfStay({
      start: null,
      end: null,
    });
    this.didDateOfStayChange(dateOfStay);
  }

  /**
   * Triggered when end date is blurred
   * Shows date picker and reset dateOfStay's end
   * date property.
   */
  onEndDateBlurred() {
    this.showDates = true;

    const dateOfStayValue = this.dateOfStay();
    if (dateOfStayValue && dateOfStayValue.start) {
      const dateOfStay = new DateOfStay({
        start: dateOfStayValue.start,
        end: null,
      });

      this.didDateOfStayChange(dateOfStay);
    }
  }

  abstract didDateOfStayChange(dateOfStay: DateOfStay): void;
  abstract didDestinationChange(destination: Destination | null): void;
}
